import {get} from 'lodash';

export default (state = {}, {customerId, data}: any) => {
  return {
    ...state,
    startDate: {
      ...get(state, 'startDate', {}),
      [customerId]: data,
    },
  };
};
